import { IconButton, Typography } from "@mui/material";
import React, { useContext, useEffect } from "react";
import stateContext from "../../Context/StateContext";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../api/client";

const StoneStyle = ({ activeStone, setActiveStone }) => {
    const globalState = useContext(stateContext);

    const { data: charmData, isSuccess } = useQuery({
        queryKey: ["charms"],
        queryFn: () =>
            apiClient.get("/charms", {
                params: {
                    status: "Available",
                    minPrice: 0,
                    maxPrice: 5000,
                },
            }),
    });

    useEffect(() => {
        if (isSuccess && charmData.length > 0) {
            showContent(charmData[0]);
        }
    }, [isSuccess]);

    const showContent = (charm) => {
        hideAllCharms();

        const charmRef = globalState.charmRefs?.[charm.charm];
        if (charmRef && charmRef.current) {
            charmRef.current.visible = true;
        }

        globalState.setSelectedCharm(charm.charm);
        globalState.setSelectedCharmData(charm);
        setActiveStone(charm.charm);

        const charmPrice = parseInt(charm.price) || 0;
        globalState.setPrices((prev) => ({
            ...prev,
            charmPrice,
        }));

        const defaultColor = charm.colors?.available?.[0]?.code || "#ffffff";
        globalState.setCharmColor(defaultColor);
        
    };

    const hideAllCharms = () => {
        Object.values(globalState.charmRefs || {}).forEach((ref) => {
            if (ref.current) ref.current.visible = false;
        });
        globalState.setSelectedCharm("shape-none");
    };

    const isArabic = globalState.selectedFontLanguage === "Arabic";

    return (
        <>
            <div className="tabpanel__content-boxes tabpanel__content-boxes--4col">
                {/* NONE Option */}
                <div
                    className={`tabpanel__content-box ${
                        activeStone === "None" ? "active" : ""
                    }`}
                    key="none-option"
                >
                    <IconButton
                        className="inheritMuiIconButton"
                        onClick={() => {
                            hideAllCharms();
                            setActiveStone("None");
                            globalState.setCharmColor("#ffffff");
                            globalState.setSelectedCharm("shape-none");
                            globalState.setSelectedCharmData({});
                            globalState.setPrices((prev) => ({
                                ...prev,
                                charmPrice: 0,
                                socketPrices: 0,
                            }));
                        }}
                    >
                        <span className="inheritMuiIconButton-container">
                            <span className="tabpanel__content-box-label">
                                {isArabic ? "بدون" : "None"}
                            </span>
                        </span>
                    </IconButton>
                </div>

                {/* Actual Charm Data */}
                {isSuccess &&
                    charmData?.data?.map((item) => (
                        <div
                            className={`tabpanel__content-box ${
                                item.charm === activeStone ? "active" : ""
                            }`}
                            key={item.id}
                        >
                            <IconButton
                                className="inheritMuiIconButton"
                                onClick={() => showContent(item)}
                            >
                                <span className="inheritMuiIconButton-container">
                                    <span className="tabpanel__content-box-icon tabpanel__content-box-icon--48">
                                        <img
                                            src={`${process.env.REACT_APP_FILE_BASE_URL}${item.imageFileKey}`}
                                            alt={item.charm}
                                            className="tabpanel__content-box-icon-img"
                                        />
                                    </span>
                                    <span className="tabpanel__content-box-label">
                                        {isArabic && item.arabicName
                                            ? item.arabicName
                                            : item.charm}
                                    </span>
                                    <span className="tabpanel__content-box-label">
                                        SAR {item.price}
                                    </span>
                                </span>
                            </IconButton>
                        </div>
                    ))}
            </div>

            {/* Colors if any */}
            <Typography
                variant="subtitle2"
                className="tabpanel__content-subtitle"
                style={{ userSelect: "none" }}
            >
                {isArabic ? "لون الحجر" : "Stone Color"}
            </Typography>

            {activeStone === "None" ||
            !globalState.selectedCharmData?.colors?.available?.length ? (
                <div
                    id="shape-none"
                    className="tabpanel__content-boxes tabpanel__content-boxes--1col active"
                >
                    {isArabic ? "لم يتم تحديد الحجر!!" : "Stone not selected!!"}
                </div>
            ) : (
                <div className="tabpanel__content-boxes tabpanel__content-boxes--4col ">
                    {globalState.selectedCharmData.colors.available.map(
                        (item, index) => (
                            <div
                                className={`tabpanel__content-box ${
                                    globalState.charmColor === item.code
                                        ? "active"
                                        : ""
                                }`}
                                style={item.stock === 0 ? { backgroundColor: '#f0f0f0' } : {}}
                                key={index}
                            >
                                <IconButton
                                    className="inheritMuiIconButton"
                                    disabled={item.stock === 0}
                                    onClick={() => {
                                        if (item.stock > 0) {
                                            globalState.setCharmColor(item.code);
                                            globalState.setCharmColorName(
                                                item.name
                                            );
                                        }
                                    }}
                                >
                                    <span className="inheritMuiIconButton-container">
                                        <span className="tabpanel__content-box-icon tabpanel__content-box-icon--64">
                                            {item.imageFile ? (
                                                <img
                                                    src={`${
                                                        item.imageFile.startsWith(
                                                            "assets/"
                                                        )
                                                            ? process.env
                                                                  .PUBLIC_URL +
                                                              "/" +
                                                              item.imageFile
                                                            : process.env
                                                                  .REACT_APP_FILE_BASE_URL +
                                                              item.imageFile
                                                    }`}
                                                    alt={item.name}
                                                    className="tabpanel__content-box-icon-img"
                                                />
                                            ) : (
                                                <div
                                                    style={{
                                                        backgroundColor:
                                                            item.code,
                                                        width: 48,
                                                        height: 48,
                                                        borderRadius: "50%",
                                                        border:
                                                            globalState.charmColor ===
                                                            item.code
                                                                ? "2px solid #000"
                                                                : "1px solid #ccc",
                                                    }}
                                                />
                                            )}
                                        </span>
                                        <span 
                                            className="tabpanel__content-box-label"
                                            style={item.stock === 0 ? { color: '#999' } : {}}
                                        >
                                            {isArabic && item.arabicName
                                                ? item.arabicName
                                                : item.name}
                                            {item.stock === 0 && (
                                                <span style={{ display: 'block', fontSize: '12px', color: '#999' }}>
                                                    Out Of Stock
                                                </span>
                                            )}
                                        </span>
                                    </span>
                                </IconButton>
                            </div>
                        )
                    )}
                </div>
            )}
        </>
    );
};

export default StoneStyle;
